import { createContext } from 'react';
import { IPolicyContextState } from './state/IPolicyContextState';

export const PolicyContext = createContext<IPolicyContextState>({} as IPolicyContextState);
